module.exports = __webpack_public_path__ + "9b9ace39b10a370474774b3a1d7896f4.svg";